<div class="header-label">Jobs</div>
<div class="flex-fill d-flex flex-column content-block dx-card p-3">
  <div class="row d-flex flex-fill flex-row">
    <div class="col-sm-7 d-flex flex-column">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="jobs"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        >
        <dxi-data-grid-column dataField="id" caption="Job #" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rental.customer.displayName" caption="Customer" width="225"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driver.displayName" caption="Driver" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="inventory.dumpsterBarcode" caption="Barcode" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="weight" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="created" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="started" format="shortDateShortTime" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAsDumpster.size" caption="Bill As" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayAddress" caption="Service Address" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driverNotes" width="350"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="job-overview-grid"></dxo-data-grid-state-storing>

        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-sm btn-warning mb-2" (click)="toggleShowUnassigned()">
            {{ showUnassigned ? 'Show Assigned' : 'Show Only Unassigned' }}
          </button>
          <button class="btn btn-sm btn-warning ms-3 mb-2" (click)="toggleShowCompleted()">
            {{ showUnCompleted ? 'Show All' : 'Show UnCompleted' }}
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (jobs) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
    <div class="col-sm-5 d-flex flex-column">
      <dx-data-grid
        #auditDataGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="unAuditedJobs"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        >
        <dxi-data-grid-column dataField="id" caption="Job #" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rental.customer.displayName" caption="Customer" width="225"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceNumber" caption="Invoice #" width="150" cellTemplate="invoiceTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="inventory.dumpsterBarcode" caption="Barcode" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="created" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="started" format="shortDateShortTime" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAsDumpster.size" caption="Bill As" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayAddress" caption="Service Address" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driverNotes" width="350"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'invoiceTemplate'">
          <a [routerLink]="'/invoices/' + cell.data.invoiceId">{{ cell.data.invoiceNumber }}</a>
        </div>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="job-overview-audit-grid"></dxo-data-grid-state-storing>

        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-sm btn-success mb-2"
            (click)="markAsAudited(auditDataGrid.instance.getSelectedRowsData())"
            [disabled]="auditDataGrid.instance.getSelectedRowsData().length === 0"
            >
            Audited
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (jobs) {
            <span class="me-3">
              <strong>{{ auditDataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
